import { hot } from "react-hot-loader";

import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";

import apolloClient from "../../../../shared/utilities/graphql/apolloClient";
import TourLikesComponent from "./TourLikes";

const TourLikes = props => (
  <ApolloProvider client={apolloClient}>
    <TourLikesComponent {...props} />
  </ApolloProvider>
);

/* eslint-disable import/no-unused-modules */
export default hot(module)(TourLikes);
